(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("FrameworkGeneratorCode", [], factory);
	else if(typeof exports === 'object')
		exports["FrameworkGeneratorCode"] = factory();
	else
		root["FrameworkGeneratorCode"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("frameworkUtil",[],t):"object"==typeof exports?exports.frameworkUtil=t():e.frameworkUtil=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(n){if(r[n])return r[n].exports;var a=r[n]={i:n,l:!1,exports:{}};return e[n].call(a.exports,a,a.exports,t),a.l=!0,a.exports}var r={};return t.m=e,t.c=r,t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/dist/",t(t.s=0)}([function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=r(1),a=r(2),u=r(3),i=r(4),s=r(5),o=r(6);t.default={Convert:n,DateUtil:a,PermissionUtil:u,CommonUtil:i,DictUtil:s,ApiService:o}},function(e,t,r){"use strict";function n(e,t){return e?parseInt(e,10):t}function a(e,t,r){return e?(e=parseFloat(e),e.toFixed(t)):r||e}Object.defineProperty(t,"__esModule",{value:!0}),t.toInt=n,t.toFix=a},function(module,__webpack_exports__,__webpack_require__){"use strict";function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(__webpack_exports__,"__esModule",{value:!0}),__webpack_require__.d(__webpack_exports__,"DateUtil",function(){return DateUtil});var _createClass=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),DateUtil=function(){function DateUtil(){_classCallCheck(this,DateUtil)}return _createClass(DateUtil,[{key:"isLeapYear",value:function(e){return 0==e.getYear()%4&&(e.getYear()%100!=0||e.getYear()%400==0)}},{key:"getCurrentDate",value:function(){return new Date}},{key:"formatDate",value:function(e){return this.format(e,"yyyy-MM-dd")}},{key:"format",value:function(e,t){t=arguments[1]||"yyyy-MM-dd HH:mm:ss",e=arguments[0]||new Date;var r=t,n=["日","一","二","三","四","五","六"];return r=r.replace(/yyyy|YYYY/,e.getFullYear()),r=r.replace(/yy|YY/,e.getYear()%100>9?(e.getYear()%100).toString():"0"+e.getYear()%100),r=r.replace(/MM/,e.getMonth()>9?e.getMonth()+1:"0"+(e.getMonth()+1)),r=r.replace(/M/g,e.getMonth()),r=r.replace(/w|W/g,n[e.getDay()]),r=r.replace(/dd|DD/,e.getDate()>9?e.getDate().toString():"0"+e.getDate()),r=r.replace(/d|D/g,e.getDate()),r=r.replace(/hh|HH/,e.getHours()>9?e.getHours().toString():"0"+e.getHours()),r=r.replace(/h|H/g,e.getHours()),r=r.replace(/mm/,e.getMinutes()>9?e.getMinutes().toString():"0"+e.getMinutes()),r=r.replace(/m/g,e.getMinutes()),r=r.replace(/ss|SS/,e.getSeconds()>9?e.getSeconds().toString():"0"+e.getSeconds()),r=r.replace(/s|S/g,e.getSeconds())}},{key:"dateAdd",value:function(e,t){return this.dateCau("d",t,e)}},{key:"dateCau",value:function(e,t,r){switch(r=arguments[2]||new Date,e){case"s":return new Date(r.getTime()+1e3*t);case"n":return new Date(r.getTime()+6e4*t);case"h":return new Date(r.getTime()+36e5*t);case"d":return new Date(r.getTime()+864e5*t);case"w":return new Date(r.getTime()+6048e5*t);case"m":return new Date(r.getFullYear(),r.getMonth()+t,r.getDate(),r.getHours(),r.getMinutes(),r.getSeconds());case"y":return new Date(r.getFullYear()+t,r.getMonth(),r.getDate(),r.getHours(),r.getMinutes(),r.getSeconds())}}},{key:"dateDiff",value:function(e,t,r){switch(e){case"s":return parseInt((r-t)/1e3);case"n":return parseInt((r-t)/6e4);case"h":return parseInt((r-t)/36e5);case"d":return parseInt((r-t)/864e5);case"w":return parseInt((r-t)/6048e5);case"m":return r.getMonth()+1+12*(r.getFullYear()-t.getFullYear())-(t.getMonth()+1);case"y":return r.getFullYear()-t.getFullYear()}}},{key:"strToDate",value:function strToDate(dateStr){var data=dateStr,reCat=/(\d{1,4})/gm,t=data.match(reCat);return t[1]=t[1]-1,eval("var d = new Date("+t.join(",")+");"),d}},{key:"strFormatToDate",value:function(e,t){var r=0,n=-1,a=t.length;(n=e.indexOf("yyyy"))>-1&&n<a&&(r=t.substr(n,4));var u=0;(n=e.indexOf("MM"))>-1&&n<a&&(u=parseInt(t.substr(n,2))-1);var i=0;(n=e.indexOf("dd"))>-1&&n<a&&(i=parseInt(t.substr(n,2)));var s=0;((n=e.indexOf("HH"))>-1||(n=e.indexOf("hh"))>1)&&n<a&&(s=parseInt(t.substr(n,2)));var o=0;(n=e.indexOf("mm"))>-1&&n<a&&(o=t.substr(n,2));var c=0;return(n=e.indexOf("ss"))>-1&&n<a&&(c=t.substr(n,2)),new Date(r,u,i,s,o,c)}},{key:"dateToLong",value:function(e){return e.getTime()}},{key:"longToDate",value:function(e){return new Date(e)}},{key:"isDate",value:function(e,t){null==t&&(t="yyyyMMdd");var r=t.indexOf("yyyy");if(-1==r)return!1;var n=e.substring(r,r+4),a=t.indexOf("MM");if(-1==a)return!1;var u=e.substring(a,a+2),i=t.indexOf("dd");if(-1==i)return!1;var s=e.substring(i,i+2);return!(!this.isNumber(n)||n>"2100"||n<"1900")&&(!(!this.isNumber(u)||u>"12"||u<"01")&&!(s>this.getMaxDay(n,u)||s<"01"))}},{key:"getMaxDay",value:function(e,t){return 4==t||6==t||9==t||11==t?"30":2==t?e%4==0&&e%100!=0||e%400==0?"29":"28":"31"}},{key:"isNumber",value:function(e){return/^\d+$/g.test(e)}},{key:"toArray",value:function(e){e=arguments[0]||new Date;var t=Array();return t[0]=e.getFullYear(),t[1]=e.getMonth(),t[2]=e.getDate(),t[3]=e.getHours(),t[4]=e.getMinutes(),t[5]=e.getSeconds(),t}},{key:"datePart",value:function(e,t){t=arguments[1]||new Date;var r="",n=["日","一","二","三","四","五","六"];switch(e){case"y":r=t.getFullYear();break;case"M":r=t.getMonth()+1;break;case"d":r=t.getDate();break;case"w":r=n[t.getDay()];break;case"ww":r=t.WeekNumOfYear();break;case"h":r=t.getHours();break;case"m":r=t.getMinutes();break;case"s":r=t.getSeconds()}return r}},{key:"maxDayOfDate",value:function(e){e=arguments[0]||new Date,e.setDate(1),e.setMonth(e.getMonth()+1);var t=e.getTime()-864e5;return new Date(t).getDate()}},{key:"getDateRange",value:function(e,t,r){var n=[],a=void 0,u=void 0;return 1==r?(a=new Date(e.getTime()-864e5*t),u=new Date(e.getTime()-864e5),n.push(this.formateDate(a)),n.push(this.formateDate(u))):(a=new Date(e.getTime()+864e5*t),u=new Date(e.getTime()-864e5),n.push(this.formateDate(a)),n.push(this.formateDate(u))),n}},{key:"formateDate",value:function(e){var t=e.getFullYear(),r=e.getMonth()+1,n=e.getDate();return r<10&&(r="0"+r),n<10&&(n="0"+n),t+"-"+r+"-"+n}}]),DateUtil}()},function(e,t,r){"use strict";function n(e){if(e&&e instanceof Array&&e.length>0){if(!window.customStore)return!1;var t=window.customStore.getters&&window.customStore.getters.permissions,r=e;if(t)for(var n=0;n<t.length;n++)if(r.includes(t[n]))return!0;return!1}return console.error("need permissions! Like v-permission=\"['admin','editor']\""),!1}Object.defineProperty(t,"__esModule",{value:!0}),t.checkPermission=n},function(e,t,r){"use strict";function n(){return"http://localhost:9091"}function a(){return"eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsImV4cCI6MTYyODA3Mjc5NSwiaWF0IjoxNTk2NTM2Nzk1fQ.YpGCYmQwgOwxfpA12ke-uG0tlRT0pZ5ItMV1X7hcrqJS4zewft2baI6KsBgw5L3BMHmKy6rhwrTzqwCS5l2bfQ"}Object.defineProperty(t,"__esModule",{value:!0}),t.getUrl=n,t.getTokenInfo=a},function(e,t,r){"use strict";function n(){return custemRequest({url:"dict/formType",method:"get"})}function a(){return custemRequest({url:"dict/config",method:"get"})}function u(){return custemRequest({url:"dict/config/id",method:"get"})}function i(e,t){return custemRequest({url:"dict/list",method:"get",params:{dictId:e,index:t}})}function s(e,t,r){return custemRequest({url:"dict/link/list",method:"get",params:{dictId:e,index:r,pId:t}})}function o(e,t){return custemRequest({url:"dict/list/id",method:"get",params:{dictId:e,index:t}})}function c(e,t){return custemRequest({url:"dict/list/code",method:"get",params:{code:e,index:t}})}function l(e,t){return custemRequest({url:"dict/listTree",method:"get",params:{dictId:e,index:t}})}function d(e,t,r){return custemRequest({url:"dict/linkList/id",method:"get",params:{index:r,dictId:e,pId:t}})}function f(e,t,r){return custemRequest({url:e,method:"get",params:{index:r,pId:t}})}function g(e){return custemRequest({url:"sysFjxxMul/getFiles",method:"get",params:{recordId:e}})}Object.defineProperty(t,"__esModule",{value:!0}),t.getFormType=n,t.getDictConfig=a,t.getDictConfigIdService=u,t.getDictList=i,t.getLinkList=s,t.getDictIdList=o,t.getDictListByCode=c,t.getDictTreeList=l,t.getDictIdLinkList=d,t.getUrlLinkList=f,t.getFilesService=g},function(e,t,r){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),r.d(t,"ApiService",function(){return u});var a=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),u=function(){function e(t){n(this,e),this.baseUrl=t}return a(e,[{key:"list",value:function(e,t){var r=this.baseUrl+"/list";return t&&(r+="/"+t),custemRequest({url:r,method:"get",params:e})}},{key:"all",value:function(e){return custemRequest({url:this.baseUrl+"/all",method:"get",params:e})}},{key:"tree",value:function(e){return custemRequest({url:this.baseUrl+"/tree",method:"get",params:e})}},{key:"create",value:function(e,t){var r=this.baseUrl;return t&&(r+="/"+t),custemRequest({url:r,method:"post",data:e})}},{key:"update",value:function(e,t,r){var n=this.baseUrl+"/"+e;return r&&(n=this.baseUrl+"/"+r+"/"+e),custemRequest({url:n,method:"put",data:t})}},{key:"delete",value:function(e,t){var r=this.baseUrl+"/"+e;return t&&(r=this.baseUrl+"/"+t+"/"+e),custemRequest({url:r,method:"delete"})}},{key:"view",value:function(e){return custemRequest({url:this.baseUrl+"/"+e,method:"get"})}},{key:"viewDisplay",value:function(e){return custemRequest({url:this.baseUrl+"/view/"+e,method:"get"})}},{key:"save",value:function(e){return custemRequest({url:this.baseUrl,method:"post",data:e})}},{key:"exportData",value:function(e,t,r){var n=this.baseUrl+"/export";t&&(n+="/"+t);var a="";for(var u in e)e[u]&&(a+="&"+u+"="+e[u]);n+="?"+a,n+="&Authorization="+r,n=window.getLocationUrl()+"/"+n,window.open(n)}},{key:"modifyByUrl",value:function(e,t,r){var n=this.baseUrl+"/"+e;return n.indexOf("?")>=0?n+="&":n+="?",n+="modelId="+r,custemRequest({url:n,method:"post",data:t})}}]),e}()}])});
//# sourceMappingURL=build.js.map

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_framework_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_framework_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_framework_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_generator_generator_generalTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_generator_generator_generalStrategy__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_generator_generator_generalField__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_table_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_strategy_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_fields_js__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'SplitpaneDemo',
	components: {},
	data: function data() {
		return {
			activeStep: 1,
			tableId: '',
			saveStrategyLoading: false,
			saveFieldLoading: false,
			filedList: [],
			listLoading: false,
			formTypeData: [],
			dictConfigData: [],
			tableConfigData: __WEBPACK_IMPORTED_MODULE_4__config_table_js__["a" /* TABLE_DATA_CONFIG */],
			strategyConfigData: __WEBPACK_IMPORTED_MODULE_5__config_strategy_js__["a" /* STRATEGY_DATA_CONFIG */],
			fieldConfigData: __WEBPACK_IMPORTED_MODULE_6__config_fields_js__["a" /* FIELD_DATA_CONFIG */],
			generalTableService: __WEBPACK_IMPORTED_MODULE_1__api_generator_generator_generalTable__["a" /* generalTableService */],
			generalStrategyService: __WEBPACK_IMPORTED_MODULE_2__api_generator_generator_generalStrategy__["a" /* generalStrategyService */],
			generalFieldService: __WEBPACK_IMPORTED_MODULE_3__api_generator_generator_generalField__["a" /* generalFieldService */]
		};
	},
	mounted: function mounted() {
		//this.createFormType();
		//this.createDictConfig();
		this.getFormTypeMethod();
		this.getDictConfitMethod();
	},

	methods: {
		stragetyonfig: function stragetyonfig(row) {
			var that = this;
			this.tableId = row.id;
			__WEBPACK_IMPORTED_MODULE_1__api_generator_generator_generalTable__["a" /* generalTableService */].update(row.id, row).then(function (res) {
				that.activeStep = 2;
				that.selectStragety();
			});
		},
		selectStragety: function selectStragety() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_2__api_generator_generator_generalStrategy__["a" /* generalStrategyService */].all({
				tableId: this.tableId
			}).then(function (res) {
				if (res.length > 0) {
					that.strategyConfigData.formModel = res[0];
				} else {
					for (var p in that.strategyConfigData.formModel) {
						//遍历json数组时，这么写p为索引，0,1
						that.strategyConfigData.formModel[p] = '';
					}
					that.strategyConfigData.formModel.tableId = that.tableId;
				}
			});
		},
		getFormTypeMethod: function getFormTypeMethod() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_0_framework_util___default.a.DictUtil.getFormType().then(function (res) {
				that.formTypeData = res;
			});
		},
		getDictConfitMethod: function getDictConfitMethod() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_0_framework_util___default.a.DictUtil.getDictConfig().then(function (res) {
				that.dictConfigData = res.data;
			});
		},
		back: function back() {
			this.activeStep = 1;
		},
		prvBack: function prvBack() {
			this.activeStep = 2;
		},
		saveFieldInfo: function saveFieldInfo() {
			var that = this;
			Object(__WEBPACK_IMPORTED_MODULE_3__api_generator_generator_generalField__["b" /* saveAllService */])(this.tableId, this.filedList).then(function (res) {
				that.getAllFileds(that.tableId);
			});
		},
		saveStrategyForm: function saveStrategyForm() {
			this.$refs.strategyForm.submitForm();
		},
		saveStrategy: function saveStrategy(data) {
			var that = this;
			if (data.id) {
				__WEBPACK_IMPORTED_MODULE_2__api_generator_generator_generalStrategy__["a" /* generalStrategyService */].update(data.id, data).then(function (res) {
					that.activeStep = 3;
					that.getAllFileds(data.tableId);
				});
			} else {
				__WEBPACK_IMPORTED_MODULE_2__api_generator_generator_generalStrategy__["a" /* generalStrategyService */].create(data).then(function (res) {
					that.activeStep = 3;
					that.getAllFileds(data.tableId);
					//that.getAllFileds(data.tableId);
				});
			}
		},
		getAllFileds: function getAllFileds(tableId) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__api_generator_generator_generalField__["a" /* generalFieldService */].all({
				tableId: tableId
			}).then(function (res) {
				that.filedList = res;
			});
		}
	}
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_generator_generator_sysDict_js__ = __webpack_require__(15);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      testData: [],
      configData: __WEBPACK_IMPORTED_MODULE_0__config_config_js__["a" /* DATA_CONFIG */],
      sysDictServiceApi: __WEBPACK_IMPORTED_MODULE_1__api_generator_generator_sysDict_js__["a" /* sysDictService */]
    };
  },

  name: 'sysDict-list',
  mounted: function mounted() {},

  methods: {}
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generator_createCode_index_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generator_sysDict_index_vue__ = __webpack_require__(13);



var customChart = {
  FwGeneratorCreateCode: __WEBPACK_IMPORTED_MODULE_0__generator_createCode_index_vue__["a" /* default */], FwGeneratorSysDict: __WEBPACK_IMPORTED_MODULE_1__generator_sysDict_index_vue__["a" /* default */]
};

var install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  Vue.component("FwGeneratorCreateCode", __WEBPACK_IMPORTED_MODULE_0__generator_createCode_index_vue__["a" /* default */]);
  Vue.component("FwGeneratorSysDict", __WEBPACK_IMPORTED_MODULE_1__generator_sysDict_index_vue__["a" /* default */]);
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

/* harmony default export */ __webpack_exports__["default"] = (Object.assign(customChart, { install: install }));

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0782c9ab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(12);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0782c9ab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generalTableService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_framework_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_framework_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_framework_util__);

var generalTableService = new __WEBPACK_IMPORTED_MODULE_0_framework_util___default.a.ApiService.ApiService('generalTable');

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generalStrategyService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_framework_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_framework_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_framework_util__);

var generalStrategyService = new __WEBPACK_IMPORTED_MODULE_0_framework_util___default.a.ApiService.ApiService('generalStrategy');

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generalFieldService; });
/* harmony export (immutable) */ __webpack_exports__["b"] = saveAllService;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_framework_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_framework_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_framework_util__);

var generalFieldService = new __WEBPACK_IMPORTED_MODULE_0_framework_util___default.a.ApiService.ApiService('generalField');

function saveAllService(tableId, data) {

  return custemRequest({
    url: 'generalField/saveAll/tableId/' + tableId,
    method: 'post',
    data: data
  });
}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TABLE_DATA_CONFIG; });
var TABLE_DATA_CONFIG = {
  gridConfig: [{ label: '编码',
    prop: 'code' }, { label: '中文名',
    prop: 'name',
    render: function render(h, params) {
      return h('input', {
        class: 'el-input__inner',
        domProps: {
          value: params.row.name
        },
        on: {
          input: function input(event) {
            params.row.name = event.target.value;
          }
        }
      });
    }
  }],
  dialogConfig: {
    width: '50%',
    labelWidth: '120px'
  },
  queryConfig: [{ span: 12,
    label: '代码',
    prop: 'code',
    type: 'text',
    data: []
  }, { span: 12,
    label: '名称',
    prop: 'name',
    type: 'text',
    data: []
  }],
  // crud的模态框表单配置，可配置表单类型，验证规则，是否必填,col-span布局可通过span参数配置
  formConfig: [{ span: 24,
    label: '代码',
    prop: 'code',
    type: 'text',
    rules: { required: true,
      message: '请输入表编码',
      trigger: 'blur'
    },
    data: []
  }, { span: 24,
    label: '名称',
    prop: 'name',
    type: 'text',
    rules: { required: true,
      message: '请输入表名称',
      trigger: 'blur'
    },
    data: []
  }],
  gridTopBtnConfig: [{
    'name': '新建',
    'type': null,
    'classify': 'create',
    'index': 0,
    'location': 'top',
    'roles': [],
    'modelId': null,
    'actionUrl': ''
  }, {
    'name': '重置',
    'type': null,
    'classify': 'reset',
    'index': 1,
    'location': 'top',
    'roles': [],
    'modelId': null,
    'actionUrl': ''
  }, {
    'name': '导出',
    'type': null,
    'classify': 'export',
    'index': 2,
    'location': 'top',
    'roles': [],
    'modelId': null,
    'actionUrl': ''
  }],
  //
  gridBtnConfig: [{
    'name': '删除',
    'type': null,
    'classify': 'delete',
    'index': 1,
    'location': 'grid',
    'roles': [],
    'modelId': null,
    'actionUrl': ''
  }, {
    emitName: 'stragetyonfig',
    'name': '配置',
    'type': null,
    'classify': 'stragetyonfig',
    'index': 1,
    'location': 'grid',
    'roles': [],
    'actionUrl': ''
  }],
  // 表单基础数据类型，需要预先赋值
  formModel: {
    'id': '',
    'code': '',
    'name': ''
  },
  queryModel: {}
};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STRATEGY_DATA_CONFIG; });
var STRATEGY_DATA_CONFIG = {
  // crud的模态框表单配置，可配置表单类型，验证规则，是否必填,col-span布局可通过span参数配置
  formConfig: [{ span: 24,
    label: '作者',
    prop: 'author',
    type: 'text',
    rules: { required: true,
      message: '请输入作者名称',
      trigger: 'blur'
    },
    data: []
  }, { span: 24,
    label: '生成DAO',
    prop: 'createMapper',
    type: 'select',
    rules: {
      required: true,
      message: '请选择生成DAO',
      trigger: 'change'
    },
    dataScource: '5396f45325844eb4382ad6aa130429dd',
    data: []
  }, { span: 24,
    label: '生成Service',
    prop: 'createService',
    type: 'select',
    rules: {
      required: true,
      message: '请选择生成Service',
      trigger: 'change'
    },
    dataScource: '5396f45325844eb4382ad6aa130429dd',
    data: []
  }, { span: 24,
    label: '生成Controller',
    prop: 'createController',
    type: 'select',
    rules: {
      required: true,
      message: '请选择生成Controller',
      trigger: 'change'
    },
    dataScource: '5396f45325844eb4382ad6aa130429dd',
    data: []
  }, { span: 24,
    label: '生成前端',
    prop: 'createFront',
    type: 'select',
    rules: {
      required: true,
      message: '请选择生成前端',
      trigger: 'change'
    },
    dataScource: '5396f45325844eb4382ad6aa130429dd',
    data: []
  }, { span: 24,
    label: '前端路径',
    prop: 'frontPath',
    type: 'text',
    data: []
  }, { span: 24,
    label: '后端路径',
    prop: 'backPath',
    type: 'text',
    data: []
  }, { span: 24,
    label: '包名',
    prop: 'packageName',
    type: 'text',
    data: []
  }, { span: 24,
    label: '模块',
    prop: 'frontModule',
    type: 'text',
    data: []
  }, { span: 24,
    label: '表前缀',
    prop: 'tablePrefix',
    type: 'text',
    data: []
  }],
  dialogConfig: {
    labelWidth: '120px'
  },
  // crud的操作按钮配置，基础按钮有添加、修改、删除、查看，还可以配置扩展按钮
  gridBtnConfig: {
    create: true, update: true, delete: true, view: false
  },
  // 表单基础数据类型，需要预先赋值
  formModel: {
    'id': '',
    'author': '',
    'createMapper': '',
    'createService': '',
    'createController': '',
    'createFront': '',
    'frontPath': '',
    'backPath': '',
    'frontModule': '',
    'tableId': '',
    'tablePrefix': '',
    'packageName': ''
  },
  queryModel: {}
};

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIELD_DATA_CONFIG; });
var FIELD_DATA_CONFIG = {
  gridConfig: [{ label: '编码',
    prop: 'fieldCode' }, { label: '名称',
    prop: 'fieldName',
    render: function render(h, params) {
      return h('input', {
        class: 'el-input__inner',
        domProps: {
          value: params.row.name
        },
        on: {
          input: function input(event) {
            params.row.name = event.target.value;
          }
        }
      });
    }
  }, { label: '是否查询',
    prop: 'canQuery',
    render: function render(h, params) {
      return h('input', {
        class: 'el-input__inner',
        domProps: {
          value: params.row.name
        },
        on: {
          input: function input(event) {
            params.row.name = event.target.value;
          }
        }
      });
    }
  }],
  dialogConfig: {
    width: '50%',
    labelWidth: '120px'
  },
  queryConfig: [],
  // crud的模态框表单配置，可配置表单类型，验证规则，是否必填,col-span布局可通过span参数配置
  formConfig: [{ span: 24,
    label: '代码',
    prop: 'code',
    type: 'text',
    rules: { required: true,
      message: '请输入表编码',
      trigger: 'blur'
    },
    data: []
  }, { span: 24,
    label: '名称',
    prop: 'name',
    type: 'text',
    rules: { required: true,
      message: '请输入表名称',
      trigger: 'blur'
    },
    data: []
  }],
  // crud的操作按钮配置，基础按钮有添加、修改、删除、查看，还可以配置扩展按钮
  gridBtnConfig: {
    create: true, update: false, delete: true, view: false,
    expands: [{
      emitName: 'stragetyonfig',
      name: '配置'
    }]
  },
  // 表单基础数据类型，需要预先赋值
  formModel: {
    'id': '',
    'code': '',
    'name': '',
    'tableId': ''
  },
  queryModel: {
    'tableId': ''
  }
};

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.activeStep===1)?_c('fw-table',{attrs:{"apiService":_vm.generalTableService,"grid-config":_vm.tableConfigData.gridConfig,"grid-btn-config":_vm.tableConfigData.gridBtnConfig,"grid-top-btn-config":_vm.tableConfigData.gridTopBtnConfig,"form-config":_vm.tableConfigData.formConfig,"form-data":_vm.tableConfigData.formModel,"grid-edit-width":200,"form-title":"表信息","is-async":true,"query-config":_vm.tableConfigData.queryConfig,"query-model":_vm.tableConfigData.queryModel,"dialog-config":_vm.tableConfigData.dialogConfig},on:{"stragetyonfig":_vm.stragetyonfig}}):_vm._e(),_vm._v(" "),(_vm.activeStep===2)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('fw-form',{ref:"strategyForm",attrs:{"form-config":_vm.strategyConfigData.formConfig,"form-data":_vm.strategyConfigData.formModel,"dialog-config":_vm.strategyConfigData.dialogConfig},on:{"submit":_vm.saveStrategy}}),_vm._v(" "),_c('span',[_c('el-button',{staticClass:"ml-10",attrs:{"type":"warning"},on:{"click":_vm.back}},[_vm._v("返回")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveStrategyForm}},[(!_vm.saveStrategyLoading)?_c('span',[_vm._v("下一步")]):_c('span',[_vm._v("保 存 中...")])])],1)],1):_vm._e(),_vm._v(" "),(_vm.activeStep===3)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.filedList,"border":"","fit":"","highlight-current-row":""}},[_c('el-table-column',{attrs:{"align":"center","label":"编码"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.fieldCode))])]}}],null,false,3186339913)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"名称"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-input',{staticClass:"edit-input",attrs:{"size":"small"},model:{value:(row.fieldName),callback:function ($$v) {_vm.$set(row, "fieldName", $$v)},expression:"row.fieldName"}})]}}],null,false,1073957817)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"是否查询条件"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-checkbox',{attrs:{"true-label":"1","false-label":"0"},model:{value:(row.canQuery),callback:function ($$v) {_vm.$set(row, "canQuery", $$v)},expression:"row.canQuery"}})]}}],null,false,1666997598)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"查询顺序"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-input',{staticClass:"edit-input",attrs:{"size":"small"},model:{value:(row.queryIndex),callback:function ($$v) {_vm.$set(row, "queryIndex", $$v)},expression:"row.queryIndex"}})]}}],null,false,3081308744)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"是否表格显示"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-checkbox',{attrs:{"true-label":"1","false-label":"0"},model:{value:(row.canTable),callback:function ($$v) {_vm.$set(row, "canTable", $$v)},expression:"row.canTable"}})]}}],null,false,217794890)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"表格显示顺序"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-input',{staticClass:"edit-input",attrs:{"size":"small"},model:{value:(row.tableIndex),callback:function ($$v) {_vm.$set(row, "tableIndex", $$v)},expression:"row.tableIndex"}})]}}],null,false,1520448476)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"是否表单显示"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-checkbox',{attrs:{"true-label":"1","false-label":"0"},model:{value:(row.canForm),callback:function ($$v) {_vm.$set(row, "canForm", $$v)},expression:"row.canForm"}})]}}],null,false,3311409058)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"显示类型"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(row.formType),callback:function ($$v) {_vm.$set(row, "formType", $$v)},expression:"row.formType"}},_vm._l((_vm.formTypeData),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.label,"value":item.id}})}),1)]}}],null,false,4097602526)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"是否必填"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-checkbox',{attrs:{"true-label":"1","false-label":"0"},model:{value:(row.formRequired),callback:function ($$v) {_vm.$set(row, "formRequired", $$v)},expression:"row.formRequired"}})]}}],null,false,3162225031)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"最小值"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-input',{staticClass:"edit-input",attrs:{"size":"small"},model:{value:(row.formMin),callback:function ($$v) {_vm.$set(row, "formMin", $$v)},expression:"row.formMin"}})]}}],null,false,1410976288)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"是否必填"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-input',{staticClass:"edit-input",attrs:{"size":"small"},model:{value:(row.formMax),callback:function ($$v) {_vm.$set(row, "formMax", $$v)},expression:"row.formMax"}})]}}],null,false,414166654)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"数据源"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(row.dataSourceId),callback:function ($$v) {_vm.$set(row, "dataSourceId", $$v)},expression:"row.dataSourceId"}},_vm._l((_vm.dictConfigData),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.label,"value":item.id}})}),1)]}}],null,false,3340667086)})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","text-align":"center"}},[_c('el-button',{staticClass:"ml-10",attrs:{"type":"warning"},on:{"click":_vm.back}},[_vm._v("返回")]),_vm._v(" "),_c('el-button',{staticClass:"ml-10",attrs:{"type":"warning"},on:{"click":_vm.prvBack}},[_vm._v("上一步")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveFieldInfo}},[(!_vm.saveFieldLoading)?_c('span',[_vm._v("生成")]):_c('span',[_vm._v("保 存 中...")])])],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6e14c8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(16);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6e14c8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATA_CONFIG; });
var DATA_CONFIG = {
  gridConfig: [{ label: '代码',
    prop: 'code' }, { label: '名称',
    prop: 'name' }, { label: '排序',
    prop: 'px' }],
  dialogConfig: {
    width: '50%',
    labelWidth: '120px'
  },
  queryConfig: [],
  // crud的模态框表单配置，可配置表单类型，验证规则，是否必填,col-span布局可通过span参数配置
  formConfig: [{ span: 24,
    label: '代码',
    prop: 'code',
    type: 'text',
    rules: { required: true,
      message: '请输入字典表代码',
      trigger: 'blur'
    },
    dataScource: 1,
    data: []

  }, { span: 24,
    label: '名称',
    prop: 'name',

    type: 'text',
    rules: { required: true,
      message: '请输入字典表名称',
      trigger: 'blur'
    },
    dataScource: 1,
    data: []

  }, { span: 24,
    label: '排序',
    prop: 'px',

    type: 'text',
    rules: { required: true,
      message: '请输入排序',
      trigger: 'blur'
    },
    dataScource: 1,
    data: []

  }],
  gridTopBtnConfig: [{
    'name': '新建',
    'type': null,
    'classify': 'create',
    'index': 0,
    'location': 'top',
    'roles': [],
    'modelId': null,
    'actionUrl': ''
  }],
  gridBtnConfig: [{
    'name': '修改',
    'type': null,
    'classify': 'update',
    'index': 1,
    'location': 'grid',
    'roles': [],
    'actionUrl': ''
  }, {
    'name': '删除',
    'type': null,
    'classify': 'delete',
    'index': 2,
    'location': 'grid',
    'roles': [],
    'modelId': null,
    'actionUrl': ''
  }],
  // crud的操作按钮配置，基础按钮有添加、修改、删除、查看，还可以配置扩展按钮
  // gridBtnConfig: {
  //   create: true, update: true, delete: true, view: false,

  // },
  // 表单基础数据类型，需要预先赋值
  formModel: {
    'id': '',
    'code': '',

    'name': '',

    'px': '',

    'type': ''

  },
  queryModel: {}
};

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sysDictService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_framework_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_framework_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_framework_util__);


var sysDictService = new __WEBPACK_IMPORTED_MODULE_0_framework_util___default.a.ApiService.ApiService('sysDict');


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fw-table',{attrs:{"apiService":_vm.sysDictServiceApi,"grid-config":_vm.configData.gridConfig,"grid-btn-config":_vm.configData.gridBtnConfig,"form-config":_vm.configData.formConfig,"form-data":_vm.configData.formModel,"grid-edit-width":200,"form-title":"字典表信息","is-async":true,"query-config":_vm.configData.queryConfig,"query-model":_vm.configData.queryModel,"dialog-config":_vm.configData.dialogConfig,"grid-top-btn-config":_vm.configData.gridTopBtnConfig}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// build.js